module.exports = __webpack_public_path__ + "img/howto_img_08.17435f9d.jpg";